import * as React from "react";
import { SVGProps, memo } from "react";

const SvgHistory = (props: SVGProps<SVGSVGElement>) => (
  <svg width={25} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.66 7.799a.9.9 0 0 1 .9-.9h5.874a.9.9 0 0 1 0 1.8h-5.875a.9.9 0 0 1-.9-.9ZM11.56 11.1a.9.9 0 0 0 0 1.8h5.874a.9.9 0 0 0 0-1.8h-5.875ZM10.66 16.201a.9.9 0 0 1 .9-.9h5.874a.9.9 0 0 1 0 1.8h-5.875a.9.9 0 0 1-.9-.9ZM7.722 6.899a.9.9 0 0 0 0 1.8h.706a.9.9 0 0 0 0-1.8h-.706ZM6.822 12a.9.9 0 0 1 .9-.9h.706a.9.9 0 0 1 0 1.8h-.706a.9.9 0 0 1-.9-.9ZM7.722 15.301a.9.9 0 0 0 0 1.8h.706a.9.9 0 1 0 0-1.8h-.706Z"
      fill="#2BA168"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.406 2.374a1.2 1.2 0 0 0-1.2 1.2v16.8a1.2 1.2 0 0 0 1.2 1.2h16.14a1.2 1.2 0 0 0 1.2-1.2v-16.8a1.2 1.2 0 0 0-1.2-1.2H4.406Zm.6 1.8v15.6h14.94v-15.6H5.006Z"
      fill="#2BA168"
    />
  </svg>
);

const Memo = memo(SvgHistory);

export default Memo;
